import type { ConfigSetting } from '@/features/products/types/products.types';
import { resolveEffectiveServiceCountBounds } from '@features/service-plans/utils/resolveServiceCountMode';

export interface AutoIncludeLinkOption {
    value: string;
    label: string;
}

interface AutoIncludePivot {
    auto_include: boolean;
    mandatory: boolean;
    auto_include_link: string | null;
}

/** `eachservice` plus `1..max_service_count` (default 10), matching the backend's regex contract. */
export function autoIncludeLinkOptions(configSettings?: ConfigSetting[] | null): AutoIncludeLinkOption[] {
    const max = resolveEffectiveServiceCountBounds(configSettings)?.max ?? 10;
    const positions = Array.from({ length: max }, (_, i) => ({
        value: String(i + 1),
        label: `With service ${i + 1}`,
    }));
    return [{ value: 'eachservice', label: 'With each service' }, ...positions];
}

/** True when `value` is empty, `eachservice`, or still present in `options`; false for a stale position. */
export function isAutoIncludeLinkSelectable(value: string | null, options: AutoIncludeLinkOption[]): boolean {
    if (!value || value === 'eachservice') return true;
    return options.some((option) => option.value === value);
}

export function summariseAutoInclude(pivot: AutoIncludePivot): string {
    if (!pivot.auto_include) return '';
    const link = pivot.auto_include_link === 'eachservice'
        ? 'each service'
        : `service ${pivot.auto_include_link ?? '?'}`;
    return pivot.mandatory ? `Auto, mandatory (${link})` : `Auto (${link})`;
}
